import React from 'react';
import PropTypes from 'prop-types';

export const McpHubLayout = ({ children }) => {
  return (<div id="mcp__hub__layout">{children}</div>)
};

McpHubLayout.propTypes = {
  children: PropTypes.any
}